export function queryRequired<T extends HTMLElement>(
  selector: string,
  context: ParentNode = document,
): T {
  const el = context.querySelector<T>(selector);
  if (!el) throw new Error(`Required element not found: ${selector}`);
  return el;
}

export function queryOptional<T extends HTMLElement>(
  selector: string,
  context: ParentNode = document,
): T | null {
  return context.querySelector<T>(selector);
}
